import React from "react";
import "./style/Admin.css";
import AdminUserTable from "./elements/AdminUserTable";
import LogoIcon from "./assets/img/logo-main.png";

export default function AdminUser() {
  document.title ='View User - Hentian Komuniti';
  return (
    <div className="d-flex">
      <div className="col-12">
        <div className="mt-2 ms-4">
          <h3 className="company-name">
            <span className="">
              <img src={LogoIcon} className="me-2 logo-merchant"></img>
            </span>
            Hentian Komuniti
          </h3>
        </div>
        <hr id="line" className="text-secondary"></hr>
        <div className="ms-4">
          <i className="bi bi-person-fill icon fs-3"></i>
          <span className="fs-5 ms-2">List of User</span>
        </div>
        <div className="">
          <AdminUserTable />
        </div>
      </div>
    </div>
  );
}
